import { isAdminOrSupervisor } from '@/services/userService';
import type { ExtendedUserResponseSchema } from '@/types/user.types';

/** Mirrors HI attempt create gating: admin/supervisor or SERVICE team. */
export const canCreatePsAttempt = (user: ExtendedUserResponseSchema | null): boolean => {
  if (!user) return false;
  if (isAdminOrSupervisor(user)) return true;
  return user.teams.some((t) => t.key === 'SERVICE');
};
